
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
// import faqData from "../data/faq.json"; // <--- इस लाइन को हटा दिया गया है

function FAQ() {
  const { t } = useTranslation();

  // i18next से सीधा Hindi/English Array उठाना
  const translatedFaqData = t("faq.questions", { returnObjects: true });

  return (
    <div className="page faq-page">

      {/* ===== PAGE HERO ===== */}
      <section className="page-hero">
        <div className="section-label">{t("faq.label")}</div>
        <h1>{t("faq.title")}</h1>
        <p>{t("faq.subtitle")}</p>
      </section>

      {/* ===== FAQ LIST ===== */}
      <section className="section-block">
        <div className="container">
          <div className="faq-container">
            {/* अब हम translatedFaqData का इस्तेमाल कर रहे हैं */}
            {Array.isArray(translatedFaqData) && translatedFaqData.map((item, index) => (
              <FAQItem
                key={item.id || index}
                question={item.question}
                answer={item.answer}
                index={index}
              />
            ))}
          </div>
        </div>
      </section>

      {/* ===== STILL HAVE QUESTIONS ===== */}
      <section className="cta-banner">
        <div className="container">
          <h2>{t("faq.stillHaveQuestions")}</h2>
          <p>{t("faq.teamReady")}</p>
          <Link to="/contact" className="btn-primary">{t("faq.contactUs")}</Link>
        </div>
      </section>
    </div>
  );
}


import FAQItem from "../components/FAQItem"; 

export default FAQ;
